var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.exportToCsv}},[_vm._t("default",function(){return [_c('vs-button',{attrs:{"color":"success","type":"filled"}},[_vm._v(_vm._s(_vm.$t('Export xls')))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }